import { AIWorker, SystemStats, TelegramNotification } from '../types';

/**
 * Initial state — shown before backend connects.
 * These are NOT fake tasks — just the default idle state of each worker.
 * Real data comes via WebSocket once backend is online.
 */

export const mockWorkers: AIWorker[] = [
  {
    id: 'claude-coder',
    name: 'Claude',
    role: 'coder',
    status: 'idle',
    avatar: '👨‍💻',
    description: 'AI Программист. Пишет код по фазам из .md файлов. Коммитит и пушит в Git.',
    engine: 'claude-code',
    model: 'claude-opus-4-7',
    completedTasks: 0,
    totalTasks: 0,
    uptime: '-',
    lastActivity: 'Ожидает подключения',
    mood: 'relaxed',
  },
  {
    id: 'claw-orchestrator',
    name: 'Claw',
    role: 'orchestrator',
    status: 'idle',
    avatar: '🦀',
    description: 'AI Менеджер. Составляет план из .md, раздаёт задачи, принимает работу.',
    engine: 'claude-code',
    model: 'claude-sonnet-4-6',
    completedTasks: 0,
    totalTasks: 0,
    uptime: '-',
    lastActivity: 'Ожидает подключения',
    mood: 'relaxed',
  },
  {
    id: 'claude-tester',
    name: 'Tess',
    role: 'tester',
    status: 'idle',
    avatar: '🔬',
    description: 'AI Тестировщик. Пишет тесты, проверяет coverage. Пока не активирована.',
    engine: 'claude-code',
    model: 'claude-haiku-4-5',
    completedTasks: 0,
    totalTasks: 0,
    uptime: '-',
    lastActivity: 'Не запущена',
    mood: 'relaxed',
  },
];

export const mockStats: SystemStats = {
  totalTasks: 0,
  completedTasks: 0,
  activeWorkers: 0,
  totalCommits: 0,
  testsPassed: 0,
  testsFailed: 0,
  coverage: 0,
  uptime: '-',
};

export const mockNotifications: TelegramNotification[] = [];
